// extracted by mini-css-extract-plugin
export default {"main":"e1bd407c97 _1734bb2a66","xmark":"_0aab3b89e7","fl_img":"eaa009a653 _603c650f7c"};